import { blue, green, grey, orange } from "@material-ui/core/colors";

export enum IncidentOrigin {
    RACE_CONTROL = "RACE_CONTROL",
    PROTEST = "PROTEST",
}

export enum IncidentOriginDescription {
    RACE_CONTROL = "Notificação",
    PROTEST = "Protesto",
}

export enum StatusIncident {
    NOTED = "NOTED",
    INVESTIGATING = "INVESTIGATING",
    AFTER_RACE = "AFTER_RACE",
    NO_FURTHER_ACTION = "NO_FURTHER_ACTION",
    APPLIED = "APPLIED",
    APPLIED_AFTER_RACE = "APPLIED_AFTER_RACE",
}

export const StatusIncidentDescription = {
    NOTED: "Anotado",
    INVESTIGATING: "Sob investigação",
    AFTER_RACE: "Pós corrida",
    NO_FURTHER_ACTION: "Nenhuma ação necessária",
    APPLIED: "Aplicado em corrida",
    APPLIED_AFTER_RACE: "Aplicado pós corrida",
};

export const StatusIncidentOrder = {
    INVESTIGATING: 1,
    NOTED: 1,
    AFTER_RACE: 2,
    NO_FURTHER_ACTION: 3,
    APPLIED: 4,
};

export const StatusIncidentColor = {
    INVESTIGATING: {
        backgroundColor: orange["600"],
        color: "white",
        fontWeight: "bold",
    },
    AFTER_RACE: {
        backgroundColor: blue["600"],
        color: "white",
        fontWeight: "bold",
    },
    NO_FURTHER_ACTION: {
        backgroundColor: grey["500"],
        color: "white",
        fontWeight: "bold",
    },
    APPLIED: {
        backgroundColor: green["500"],
        color: "white",
        fontWeight: "bold",
    },
    APPLIED_AFTER_RACE: {
        backgroundColor: green["800"],
        color: "white",
        fontWeight: "bold",
    },
};

export const isIncidentDone = (incident: Incident) => {
    return [
        StatusIncident.APPLIED,
        StatusIncident.APPLIED_AFTER_RACE,
        StatusIncident.NO_FURTHER_ACTION,
    ].includes(incident.status);
};

export const isIncidentApplied = (incident: Incident) => {
    return [
        StatusIncident.APPLIED,
        StatusIncident.APPLIED_AFTER_RACE,
    ].includes(incident.status);
};

export const isIncidentNoFurtherAction = (incident: Incident) => {
    return [
        StatusIncident.NO_FURTHER_ACTION,
    ].includes(incident.status);
};

export interface Incident {
    id?: string;
    raceControlId: string;
    lap: string;
    time?: string;
    notifiedBy: string[];
    involvedCars: string[];
    guiltyCar?: string;
    infractionId?: string;
    status: StatusIncident;
    appliedBy?: string;
    appliedAt?: any;
    comment?: string;
    protestId?: string;
    origin: IncidentOrigin;
}

export const IncidentDefaultValues: Incident = {
    raceControlId: "",
    lap: "",
    time: "",
    guiltyCar: "-1",
    notifiedBy: [],
    involvedCars: [],
    status: StatusIncident.NOTED,
    comment: "",
    origin: IncidentOrigin.RACE_CONTROL,
};
